var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96563 1.8344C2.81475 1.68868 2.61267 1.60804 2.40291 1.60986C2.19315 1.61169 1.9925 1.69582 1.84418 1.84415C1.69585 1.99247 1.61172 2.19312 1.60989 2.40288C1.60807 2.61264 1.68871 2.81472 1.83443 2.9656L13.0344 14.1656C13.1853 14.3113 13.3874 14.392 13.5972 14.3901C13.8069 14.3883 14.0076 14.3042 14.1559 14.1559C14.3042 14.0075 14.3884 13.8069 14.3902 13.5971C14.392 13.3874 14.3114 13.1853 14.1656 13.0344L12.9872 11.856C14.2333 10.8625 15.1547 9.51994 15.6336 8C14.6144 4.7544 11.5824 2.4 8.00003 2.4C6.74598 2.3983 5.50923 2.69269 4.39043 3.2592L2.96563 1.8344ZM6.37443 5.2424L7.58563 6.4544C7.8569 6.38236 8.14234 6.38284 8.41337 6.45579C8.6844 6.52873 8.93151 6.67159 9.12998 6.87005C9.32845 7.06852 9.4713 7.31564 9.54425 7.58667C9.6172 7.8577 9.61767 8.14313 9.54563 8.4144L10.7568 9.6256C11.1176 9.01442 11.265 8.30064 11.1758 7.59654C11.0865 6.89245 10.7657 6.238 10.2639 5.73614C9.76204 5.23429 9.10759 4.91352 8.40349 4.82428C7.6994 4.73505 6.98562 4.88161 6.37443 5.2424Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96326 13.3576L7.80006 11.1936C7.0222 11.1449 6.28888 10.8139 5.7377 10.2629C5.18653 9.71188 4.85539 8.97864 4.80646 8.20081L1.86806 5.26241C1.19222 6.06722 0.681934 6.99754 0.366455 8.00001C1.38566 11.2456 4.41846 13.6 8.00006 13.6C8.67766 13.6 9.33526 13.516 9.96326 13.3576Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/EyeOff.0ecfee348d4311f19e47e15adfe557e4.svg";
export { ForwardRef as ReactComponent };